import { cookies } from '@/utils/cookies'
import API from '@/assets/js/libs/API'
import { reqBaseUrl } from '@/utils/request'
import checkPointInKml from '@/assets/js/tool/checkPointInKml.js'
import kmlTool from '@/assets/js/tool/kmlTool.js'
import { counties } from '@/mocks/index.js'
import {
  getAddressInfoArray,
  getIntersectionInfoArray,
} from '@/assets/js/tool/addressUtils'
import axios from 'axios'

export default {
  data() {
    return {
      picked: 0,
      counties,
      fillLocationMethod: -1, // -1: 無選擇, 0: 主要叫車, 1: history 叫車, 2:landmark 叫車
      isConfirmLocation: false,
      searchLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      mainSelectLocaiton: {
        latitude: null,
        longitude: null,
        address: null,
      },
      autoSearchLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      intersectionLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      landmarkLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      historyLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
    }
  },
  methods: {
    selectLocationMethod(val) {
      // 為了防止選交叉路口再點擊地址輸入找不到排班站
      if (this.fillLocationMethod !== -1) {
        this.isConfirmLocation = false
        this.shiftName = ''
        this.dispatchAreaName = ''
      }
      this.setPicked(val)
      if (val === 0) return
      const locationStrategyHandler = {
        1: this.autoSearchLocationHandler,
        2: this.intersectionLocationHandler,
        3: this.landmarkLocationHandler,
        4: this.historyLocationHandler,
      }
      const pickLocationHandler = locationStrategyHandler[val]
      pickLocationHandler()
    },
    autoSearchLocationHandler() {
      const hailingStrategyLocations = [
        this.mainSelectLocaiton,
        this.historyLocation,
        this.landmarkLocation,
      ]
      if (this.fillLocationMethod !== -1) {
        const { latitude, longitude, address } =
          hailingStrategyLocations[this.fillLocationMethod]
        if (latitude !== null && longitude !== null) {
          this.isConfirmLocation = true
        }
        this.checkGPSInKml(latitude, longitude)
        this.setShowSearchLocation({ address, latitude, longitude })
        this.fillLocationMethod !== 0 && this.clearMainAddress()
      }
    },
    intersectionLocationHandler() {
      const { latitude, longitude, address } = this.intersectionLocation
      this.$refs.customerSearch.setAddressFromHistory(address)
      if (latitude !== null && longitude !== null) {
        this.isConfirmLocation = true
      }
      this.setShowSearchLocation({ latitude, longitude, address })
      this.setOnLocation({ latitude, longitude, address })
      this.checkGPSInKml(latitude, longitude)
    },
    landmarkLocationHandler() {
      this.fillLocationMethod = 2
      const { latitude, longitude, address } = this.landmarkLocation
      this.$refs.customerSearch.setAddressFromHistory(address)
      if (latitude !== null && longitude !== null) {
        this.isConfirmLocation = true
      }
      this.setShowSearchLocation({ latitude, longitude, address })
      this.setOnLocation({ latitude, longitude, address })
      this.checkGPSInKml(latitude, longitude)
    },
    historyLocationHandler() {
      this.fillLocationMethod = 1
      const { latitude, longitude, address } = this.historyLocation
      this.$refs.customerSearch.setAddressFromHistory(address)
      if (latitude !== null && longitude !== null) {
        this.isConfirmLocation = true
      }
      this.setShowSearchLocation({ latitude, longitude, address })
      this.setOnLocation({ latitude, longitude, address })
      this.checkGPSInKml(latitude, longitude)
    },
    setPicked(sectionId) {
      this.picked = sectionId
    },
    clearMainAddress() {
      this.addresses = []
      this.addressDetail = []
    },
    onOffChange(value) {
      this.reservation.off_address = value
      const address = value.trim().replace(/[ ]/g, '+')
      const intersection = address.replace('市', '市 ').replace(/[ ]/g, '+')
      const road = intersection.split('+').slice(1, 2).join('+')
      const countyCode = this.counties.find(
        (item) => intersection.indexOf(item.country) !== -1,
      ).value

      if (address.indexOf('+') === -1) {
        return this.getOffAddresList(value)
      }
      API.get(`intersectionInfo/?key=${road}&county_number=${countyCode}`)
        .then((res) => res.result)
        .then((result) => {
          if (result === 'err') return
          const [addresses, addressDetail] = getIntersectionInfoArray(
            result.intersectionInfo,
          )
          this.offaddresses = addresses
          this.offaddressDetail = addressDetail
        })
        .catch((err) => {
          console.log('intersectionInfo', err)
        })
    },
    onChange(value) {
      this.addresses = []
      this.addressDetail = []
      this.reservation.on_address = value
      const address = value.trim().replace(/[ ]/g, '+')
      const intersection = address.replace('市', '市 ').replace(/[ ]/g, '+')
      const road = intersection.split('+').slice(1, 2).join('+')
      const countyObject = this.counties.find(
        (item) => intersection.indexOf(item.country) !== -1,
      )
      const countyCode = countyObject ? countyObject.value : countyObject

      if (address.indexOf('+') === -1) {
        return this.getAddresList(value)
      }
      API.get(`intersectionInfo/?key=${road}&county_number=${countyCode}`)
        .then((res) => res.result)
        .then((result) => {
          if (result === 'err') return
          const [addresses, addressDetail] = getIntersectionInfoArray(
            result.intersectionInfo,
          )
          this.addresses = addresses
          this.addressDetail = addressDetail
        })
        .catch((err) => {
          console.log('intersectionInfo', err)
        })
    },
    customerSelected(val) {
      this.clearLocationItemData('mainSelectLocaiton')
      this.disconfirmLocation()
      if (val === undefined || val.address === null) return
      const latitude = val.gps[1]
      const longitude = val.gps[0]
      const address = val.address

      this.isConfirmLocation = true
      this.fillLocationMethod = 0
      this.hailTaxiInfo.on = { latitude, longitude, address }
      this.mainSelectLocaiton = { latitude, longitude, address }
      this.setShowSearchLocation({ latitude, longitude, address })
      this.onShowNearlyCar({ latitude, longitude })
      this.checkGPSInKml(latitude, longitude)
    },
    customerSelectedOffLcation(val) {
      if (val === undefined || val.address === null) return
      const latitude = val.gps[1]
      const longitude = val.gps[0]
      const address = val.address
      this.hailTaxiInfo.off = { latitude, longitude, address }
      this.setShowSearchOffLocation({ latitude, longitude, address })
    },
    getOffAddresList(addr) {
      const address = addr.replace(/\(.*?\)/g, '')
      this.offaddresses = []
      axios
        .get(`${reqBaseUrl()}search/address/v2/?address=${address}`, {
          headers: {
            'x-access-token': cookies.get('user'),
          },
        })
        .then((res) => res.data.result)
        .then((result) => {
          this.clearMainAddress()
          if (result === '找不到該地址') return this.$msg('找不到該地址') // 是否只剩區域剩一個
          const [addresses, addressDetail] = getAddressInfoArray(
            result.addressArray,
          )
          this.offaddresses = addresses
          this.offaddressDetail = addressDetail
          if (result.cityDistrictRoad.length !== 1) {
            this.offaddresses = this.offaddresses.concat(
              result.cityDistrictRoad,
            )
          }
        })
        .catch((err) => {
          console.log('err', err.message)
        })
    },
    getAddresList(addr) {
      const address = addr.replace(/\(.*?\)/g, '')
      this.addresses = []
      axios
        .get(`${reqBaseUrl()}search/address/v2/?address=${address}`, {
          headers: {
            'x-access-token': cookies.get('user'),
          },
        })
        .then((res) => res.data.result)
        .then((result) => {
          this.clearMainAddress()
          if (result === '找不到該地址') return this.$msg('找不到該地址') // 是否只剩區域剩一個
          const [addresses, addressDetail] = getAddressInfoArray(
            result.addressArray,
          )
          this.addresses = addresses
          this.addressDetail = addressDetail
          if (result.cityDistrictRoad.length !== 1) {
            this.addresses = this.addresses.concat(result.cityDistrictRoad)
          }
        })
        .catch((err) => {
          console.log('err', err.message)
        })
    },
    disconfirmLocation() {
      this.isConfirmLocation = false
    },
    setOnLocation({ latitude, longitude, address }) {
      this.hailTaxiInfo.on = { latitude, longitude, address }
    },
    setOffLocation({ latitude, longitude, address }) {
      this.hailTaxiInfo.off = { latitude, longitude, address }
    },
    onClickOffLocationEmpty() {
      this.$refs.customerOffSearch.clearData()
      this.hailTaxiInfo.off.latitude = null
      this.hailTaxiInfo.off.longitude = null
      this.hailTaxiInfo.off.address = null
    },
    listenAddressFromMap({ latitude, longitude, address }) {
      this.searchLocation = { latitude, longitude, address }
      this.$refs.customerSearch.setAddressFromHistory(address)
      this.onShowNearlyCar({ latitude, longitude })
      this.setOnLocation({ latitude, longitude, address })
      this.checkGPSInKml(latitude, longitude)
    },
    checkGPSInKml(lat, lng) {
      const dispatchArea = localStorage.getItem('DispatchAreaArray')
      if (dispatchArea === null) return
      const gps = [lng, lat]
      const dispatchArray = dispatchArea.split(',')
      for (let i = 0; i < dispatchArray.length; i++) {
        kmlTool.checkSingleDispathchInLocal(dispatchArray[i])
      }
      let validDispatchItem = null
      /* 為了統一派遣區的找尋準則，localstorage上的dispatch-id皆為id由小到大排列，
       * 配合圖台監控上是以疊圖的方式放置kml圖層，所以id較大的派遣區優先取得。因此
       * 此處派遣區的找尋需要倒序遍歷
       */
      for (let i = dispatchArray.length - 1; i >= 0; i--) {
        const dispatch = localStorage.getItem(`${dispatchArray[i]}`)
        const points = checkPointInKml.parseKmlToPointsArray(dispatch)
        if (points && checkPointInKml.rayCasting(gps, points) === 'in') {
          validDispatchItem = dispatchArray[i]
          break
        }
      }

      if (validDispatchItem) {
        const dispatchId = parseInt(validDispatchItem.replace('dispatch-', ''))
        this._takeCurrentShiftInfo(dispatchId)
      } else {
        this.shiftName = ''
      }
    },
    _takeCurrentShiftInfo(id) {
      this.shiftLoading = true
      API.get(`/dispatch-area/shift-info/?id=${id}`)
        .then(async (res) => {
          if (res.result === '無此派遣區資料') {
            this.shiftName = ''
            this.dispatchAreaName = ''
            this.shiftLoading = false
            return
          }
          /* 派遣區策略為「距離最近空車」時，shift-info 只回字串、不帶名稱；
           * 需另取派遣區名稱，並對齊排班策略=最近空車，否則送單會缺 shiftProgram */
          if (res.result === '最近空車策略') {
            this.assignStrategy = 3
            this.shiftName = ''
            try {
              const infoRes = await API.get(
                `/dispatch-area/info/?id=${id}&search=id`,
              )
              if (infoRes && infoRes.result && infoRes.result.name) {
                this.dispatchAreaName = infoRes.result.name
              }
            } catch (e) {
              console.error(e)
            }
            this.shiftLoading = false
            return
          }
          this.shiftName = res.result.name
          this.dispatchAreaName = res.result.dispatchName
          this.shiftLoading = false
        })
        .catch((err) => {
          this.shiftLoading = false
          alert('錯誤碼:004')
          console.error(err)
        })
    },
    setShowSearchLocation({ latitude, longitude, address }) {
      this.searchLocation = { latitude, longitude, address }
      this.reservation.on_address = this.searchLocation.address
    },
    setShowSearchOffLocation({ address }) {
      this.reservation.off_address = address
    },
    onShowNearlyCar({ latitude, longitude }) {
      API.get(`service/driver/?lat=${latitude}&lng=${longitude}`)
        .then((detail) => {
          if (detail.result === '無車輛') return (this.carNumber = '目前無車輛')
          this.carNumber =
            detail.result.length === 5
              ? '5輛車以上'
              : `${detail.result.length}輛車`
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updateLocationByIntersection({ latitude, longitude, address }) {
      this.reservation.on_address = address
      this.searchLocation = { latitude, longitude, address }
      this.intersectionLocation = { latitude, longitude, address }
      this.onShowNearlyCar({ latitude, longitude })
      this.setOnLocation({ latitude, longitude, address })
      this.checkGPSInKml(latitude, longitude)
      this.$refs.customerSearch.setAddressFromHistory(address)
      if (latitude !== null && longitude !== null) {
        this.isConfirmLocation = true
      }
    },
    updateLocationByLandmark({ latitude, longitude, address, name }) {
      if (latitude !== null && longitude !== null) {
        this.isConfirmLocation = true
      }
      const landmarkAddress = `${name}-${address}`
      this.reservation.on_address = address
      this.fillLocationMethod = 2
      this.searchLocation = {
        latitude,
        longitude,
        address: landmarkAddress,
      }
      this.landmarkLocation = {
        latitude,
        longitude,
        address: landmarkAddress,
      }
      this.$refs.customerSearch.setAddressFromHistory(landmarkAddress)
      this.onShowNearlyCar({ latitude, longitude })
      this.setOnLocation({
        latitude,
        longitude,
        address: landmarkAddress,
      })
      this.checkGPSInKml(latitude, longitude)
    },
    updateLocationByHistory({ latitude, longitude, address }) {
      this.reservation.on_address = address
      this.fillLocationMethod = 1
      this.searchLocation = { latitude, longitude, address }
      this.historyLocation = { latitude, longitude, address }
      this.$refs.customerSearch.setAddressFromHistory(address)
      this.onShowNearlyCar({ latitude, longitude })
      this.setOnLocation({ latitude, longitude, address })
    },
    clearLocationItemData(locationItem) {
      this[locationItem].latitude = null
      this[locationItem].longitude = null
      this[locationItem].address = null
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/PhoneHail/coordinatePositioning.js